module.exports = __webpack_public_path__ + "static/media/deaths.a41fa6e8.svg";